import { Component, OnInit } from '@angular/core';
import {AbstractControlOptions, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {AccountService, AlertService} from "@app/services";
import {first} from "rxjs";
import {CookiesService} from "@app/services/cookie.service";
import {CustomValidators} from "@app/providers/custom.validators";
import {NotifierService} from "angular-notifier";

@Component({
  selector: 'app-login',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.sass'],
  providers: [
  ]
})
export class ResetPasswordComponent implements OnInit {
  form: FormGroup;
  loading = false;
  submitted = false;
  token: string | null;
  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private accountService: AccountService,
    private alertService: AlertService,
    private notifierService: NotifierService
  ) { }

  ngOnInit(): void {
    this.token = this.route.snapshot.paramMap.get('token')
    this.form = this.formBuilder.group({
      confirmPassword: ['', Validators.required],
      password: ['', Validators.required]
    },{
        validators: [CustomValidators.mustMatch('password', 'confirmPassword')]
      } as AbstractControlOptions);
  }
  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  onSubmit() {
    if (!this.token){
      this.notifierService.notify('error', `No se encontro un token valido`)
      return;
    }
    this.submitted = true;

    // reset alerts on submit
    this.alertService.clear();

    // stop here if form is invalid
    if (this.form.invalid) {
      return;
    }

    this.loading = true;
    this.accountService.resetPassword(this.f['password'].value, this.token).subscribe({
      complete(): void {

      },
      next: (data:any) => {
        this.loading = false;
        if(data.status === "OK"){
          this.notifierService.notify('success', `Se ha modificado la contraseña`)
          this.router.navigateByUrl("/login");
        }

      },
      error: (error: any) => {
        console.log('error ',error);
        if(error.error.password.length>0){
          for(const item of error.error.password){
            this.notifierService.notify('error', `${item}`)
          }
        }else {
          this.notifierService.notify('error', `Ha ocurrido un error, vuelve a intentarlo`)
        }
        
        this.loading = false;
      }
    });
  }


}
